/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import "./borrowerleadformmodal.css";

export default function BorrowerLeadFormModal({
  loanPurpKeyword,
  noteRate,
  offerTerm,
  formHeading,
  showLeadFormModal,
  onHide,
}) {
  // stores the input field reference in a way that allows us to conditionally render
  // content or scroll to the element on button click.
  const [node, setNode] = useState(null);

  // watches for changes in the form.
  const formRef = useCallback((node) => {
    // node refers to the name input field in the BorrowerLeadGenerationTool
    setNode(node);
  }, []);

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showLeadFormModal}
      onHide={onHide}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{formHeading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BorrowerLeadGenerationTool
          leadSource="INHNPORT-037"
          branch="058"
          loanOfficerUid="CSTC"
          loanPurposeKeyword={loanPurpKeyword}
          offerLoanTypeKeyword="FHA"
          offerLoanProductCode="SO11S01F00"
          offerRate={noteRate}
          offerTerm={offerTerm}
          noteRate={noteRate}
          showModalBackBtn={true}
          statesDomain={process.env.REACT_APP_STATE_DOMAIN}
          ref={formRef}
          domainNameConsent="swmc.com"
        />
      </Modal.Body>
    </Modal>
  );
}